import { render, staticRenderFns } from "./ServiceCodeAddEdit.vue?vue&type=template&id=05566ee2&scoped=true"
import script from "./ServiceCodeAddEdit.vue?vue&type=script&lang=js"
export * from "./ServiceCodeAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceCodeAddEdit.vue?vue&type=style&index=0&id=05566ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05566ee2",
  null
  
)

export default component.exports